import React from 'react';
import { Lock } from 'lucide-react';
import DashboardLayout from '../DashboardLayout';

// Consistent, professional flag-OFF page state. Does NOT imply the feature is broken.
export const DisabledFeature = ({ name, note, requiresAuthorization = false, testid = 'disabled-feature' }) => (
  <div className="max-w-2xl mx-auto p-6" data-testid={testid}>
    <div className="bg-white border border-gray-200 rounded-xl p-6">
      <div className="flex items-start gap-4">
        <div className="w-11 h-11 rounded-lg bg-amber-50 flex items-center justify-center shrink-0">
          <Lock className="w-5 h-5 text-amber-600" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-gray-900">{name} — Not Enabled</h2>
          <p className="text-sm text-gray-600 mt-1">
            {note || 'This feature is built but currently disabled. Configuration is preserved; no operational actions are available.'}
          </p>
          {requiresAuthorization && (
            <p className="text-xs text-gray-400 mt-3">Enabling this capability requires Founder authorization via Feature Controls (super_admin).</p>
          )}
        </div>
      </div>
    </div>
  </div>
);

// Full-page variant wrapped in the dashboard shell.
export const DisabledFeaturePage = (props) => (
  <DashboardLayout>
    <DisabledFeature {...props} />
  </DashboardLayout>
);

export default DisabledFeature;
